(function () {
  const EMAIL_ERROR = 'Enter a valid recipient email.';
  const MATCH_ERROR = 'Recipient email and confirmation must match.';
  const SELF_ERROR = 'Use the recipient email, not the purchaser email.';
  const MEMBER_ERROR = 'That recipient already has Greenhouse member access.';
  const PENDING_ERROR = 'That recipient already has a pending gift to claim.';
  const ACTIVE_GIFT_ERROR = 'That recipient already has an active gift.';
  const CART_DUPLICATE_ERROR = 'This recipient already has a gift membership in your cart.';
  const ENDPOINT_ERROR = 'Gift eligibility is unavailable right now. Please try again in a moment.';

  function normalizeEmail(value) {
    return (value || '').trim().toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setError(container, message) {
    const target = container.querySelector('[data-gift-membership-error]');
    if (!target) return;

    if (!message) {
      target.hidden = true;
      target.textContent = '';
      return;
    }

    target.hidden = false;
    target.textContent = message;
  }

  function buildEligibilityError(checks) {
    if (!checks) return 'This recipient is not eligible right now.';
    if (checks.existingMemberAccess) return MEMBER_ERROR;
    if (checks.pendingGift) return PENDING_ERROR;
    if (checks.activeGift) return ACTIVE_GIFT_ERROR;
    return 'This recipient is not eligible right now.';
  }

  async function checkEligibility(apiUrl, email) {
    if (!apiUrl) {
      throw new Error('Gift eligibility endpoint is not configured.');
    }

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ recipientEmail: email }),
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    if (!response.ok) {
      throw new Error(payload && payload.error ? payload.error : ENDPOINT_ERROR);
    }

    return payload || { eligible: true };
  }

  async function cartHasGiftForRecipient(email) {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Cart validation failed.');
    }

    const cart = await response.json();
    return (cart.items || []).some(function (item) {
      const properties = item.properties || {};
      const fulfillmentType = properties['_Gift fulfillment type'];
      const recipientEmail = normalizeEmail(properties['Recipient email']);
      return fulfillmentType === 'membership_gift' && recipientEmail === email;
    });
  }

  function setSubmitting(form, submitting) {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.classList.toggle('loading', submitting);
    button.disabled = submitting;
  }

  function initGiftMembershipForm(container) {
    const form = container.closest('form');
    if (!form || form.dataset.giftMembershipBound === 'true') return;

    form.dataset.giftMembershipBound = 'true';

    const recipientInput = container.querySelector('[data-gift-recipient-email]');
    const confirmInput = container.querySelector('[data-gift-recipient-email-confirm]');
    const apiUrl = (container.dataset.giftApiUrl || '').trim();
    const customerEmail = normalizeEmail(container.dataset.customerEmail || '');

    form.addEventListener('submit', async function (event) {
      if (form.dataset.giftMembershipAllowSubmit === 'true') {
        form.dataset.giftMembershipAllowSubmit = 'false';
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const recipientEmail = normalizeEmail(recipientInput && recipientInput.value);
      const confirmEmail = normalizeEmail(confirmInput && confirmInput.value);

      setError(container, '');

      if (!isValidEmail(recipientEmail)) {
        setError(container, EMAIL_ERROR);
        recipientInput && recipientInput.focus();
        return;
      }

      if (recipientEmail !== confirmEmail) {
        setError(container, MATCH_ERROR);
        confirmInput && confirmInput.focus();
        return;
      }

      if (customerEmail && recipientEmail === customerEmail) {
        setError(container, SELF_ERROR);
        recipientInput && recipientInput.focus();
        return;
      }

      setSubmitting(form, true);

      try {
        const alreadyInCart = await cartHasGiftForRecipient(recipientEmail);
        if (alreadyInCart) {
          setError(container, CART_DUPLICATE_ERROR);
          setSubmitting(form, false);
          return;
        }

        const eligibility = await checkEligibility(apiUrl, recipientEmail);
        if (eligibility && eligibility.eligible === false) {
          setError(container, buildEligibilityError(eligibility.checks));
          setSubmitting(form, false);
          return;
        }

        setSubmitting(form, false);
        form.dataset.giftMembershipAllowSubmit = 'true';
        form.requestSubmit(event.submitter || form.querySelector('[type="submit"]'));
      } catch (error) {
        setError(container, error && error.message ? error.message : ENDPOINT_ERROR);
        setSubmitting(form, false);
      }
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-gift-membership-form]').forEach(initGiftMembershipForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
